<template>
  <div class="yzx-price">
    <div class="version-price-container">
      <div class="version-cards">
        <div
          v-for="(version, index) in versionList"
          :key="index"
          class="pricing-card"
        >
          <div class="left-price">
            <!-- 图标 -->
            <!-- <div class="icon-wrapper"> -->
            <img class="icon-wrapper" :src="version.iconImage" alt="" />
            <!-- </div> -->

            <!-- 标题和描述 -->
            <h3 class="title">{{ version.title }}</h3>
            <p class="subtitle">{{ version.subtitle }}</p>
            <!-- 价格 -->
            <div class="price">
              <span class="amount">{{ version.price }}</span>
              <span class="unit">{{ version.unit }}</span>
            </div>

            <!-- 按钮 -->
            <button class="btn" :class="version.btnClass" @click="btnClick">
              {{ version.btnText }}
            </button>

            <!-- 特色标签 -->
            <div v-if="version.tag" class="tag">
              {{ version.tag }}
            </div>
          </div>

          <!-- 功能列表 -->
          <div class="right-features">
            <div v-if="version.advantages" :class="version.advantagesClass">
              <span>{{ version.advantages }}</span>
            </div>
            <div class="features">
              <div
                class="features-item"
                v-for="(feature, i) in version.features"
                :key="i"
              >
                <p class="features-item_title">{{ feature.title }}</p>
                <div
                  v-for="(subTitle, subIndex) in feature.subTitle"
                  :key="subIndex"
                  class="features-item_subtitle"
                >
                  <img
                    class="check"
                    src="@/assets/images/productFeatures/success-fill.png"
                    alt=""
                  />
                  <!-- <span class="check">✓</span> -->
                  <span>{{ subTitle }}</span>
                </div>
              </div>
            </div>

            <!-- <ul class="features">
              <li v-for="(feature, i) in version.features" :key="i">
                <span>{{ feature.title }} </span>

                <span class="check">✓</span>
                <span>{{ feature }}</span>
              </li>
            </ul> -->
          </div>
        </div>
      </div>
    </div>
    <div class="module-price-container">
      <h2 class="module-title">更多功能组合供您选择</h2>
      <div class="module-cards ">
        <div
          v-for="(module, index) in moduleList"
          :key="index"
          class="module-card "
          @click="btnClick"
        >
          <!-- 图片区域 -->
          <div class="image-wrapper">
            <div class="img-box">
              <img :src="module.image" :alt="module.title" />
            </div>
          </div>

          <!-- 内容区域 -->
          <div class="module-content">
            <div>
              <h3 class="module-content_title">{{ module.title }}</h3>
              <p class="module-content_subtitle">{{ module.subtitle }}</p>
            </div>

            <div class="module-content_price">
              <span class="amount">{{ module.price }}</span>
              <span class="unit">{{ module.unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'price',
  props: {
    priceList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      versionList: [
        {
          iconImage: require('@/assets/images/yzxBuyEntrance/icon-free.png'),
          title: '易纸箱·免费版',
          alisTitle: '免费版',
          subtitle: '免费的辅助工具让您事半功倍',
          price: '免费',
          unit: '',
          btnText: '立即使用',
          btnClass: 'btn-outline',
          iconClass: 'icon-free',
          tag: '',
          advantages: '',
          advantagesClass: '',
          features: [
            {
              title: '采购管理',
              subTitle: [
                '纸板材料档案纸板材料档案建立/采购收货/报表应付账款/付款明细'
              ]
            },
            {
              title: 'AI工具👏🏻',
              subTitle: ['智能识单(买纸板/收货/对账/送货)']
            },
            {
              title: '客户管理',
              subTitle: ['客户档案']
            }
          ]
        },
        {
          iconImage: require('@/assets/images/yzxBuyEntrance/icon-agile.png'),
          title: '易纸箱·敏捷版',
          alisTitle: '敏捷版',
          subtitle: '适合2–5人的小型纸箱厂',
          price: '-',
          unit: '元/年起',
          btnText: '立即购买',
          btnClass: 'btn-primary',
          iconClass: 'icon-agile',
          tag: '',
          advantages: '拥有「免费版」全部权益，额外享有：',
          advantagesClass: 'advantages-agile',
          features: [
            {
              title: '客户管理',
              subTitle: ['查风险(司法/经营/工商)', '自动生成对账单👏🏻']
            },
            {
              title: '产品管理',
              subTitle: ['纸箱产品档案/物料管理']
            },
            {
              title: '送货管理👏🏻',
              subTitle: ['送货单建立/打印/转发/回单上传/报表对账/应收/收款明细']
            },
            {
              title: '纸箱助手👏🏻',
              subTitle: ['纸箱报价器/内外径转换/物理性能计算/单位换算']
            }
          ]
        },
        {
          iconImage: require('@/assets/images/yzxBuyEntrance/icon-pro.png'),
          title: '易纸箱·专业版',
          alisTitle: '专业版',
          subtitle: '适合5–100人的中大型纸箱厂',
          price: '-',
          unit: '元/年起',
          btnText: '立即购买',
          btnClass: 'btn-highlight',
          iconClass: 'icon-pro',
          tag: '',
          advantages: '拥有「敏捷版」全部权益，额外享有：',
          advantagesClass: 'advantages-pro',
          features: [
            {
              title: '订单管理',
              subTitle: ['纸箱、套装开单/生产单打印/进度跟踪/售后跟进']
            },
            {
              title: '采购管理',
              subTitle: ['无需重复录入，根据订单自动生成采购单', '供应商管理']
            },
            {
              title: '生产管理',
              subTitle: ['生产安排/生产跟进/生产计件']
            },
            {
              title: '仓库管理',
              subTitle: ['定制纸箱/通用纸箱/纸板/印版/刀模/辅料库存管理']
            },
            {
              title: '员工管理',
              subTitle: ['员工账号协同操作，高效管理']
            }
          ]
        }
      ],
      moduleList: [
        {
          title: '智能找版',
          subtitle: '纸箱厂效率升级武器',
          price: '-',
          unit: '元起',
          image: require('@/assets/images/yzxBuyEntrance/intellig-find.png')
        },
        {
          title: '客户风控',
          subtitle: '风险速查·实时触达',
          price: '-',
          unit: '元起',
          image: require('@/assets/images/yzxBuyEntrance/customer-risk.png')
        },
        {
          title: '纸箱报价器',
          subtitle: '适合2–5人的小型纸箱厂',
          price: '-',
          unit: '元/年起',
          image: require('@/assets/images/yzxBuyEntrance/carton-quota.png')
        }
      ]
    }
  },
  watch: {
    priceList(val) {
      if (val) {
        this.dealPrice()
      }
    }
  },
  mounted() {},
  methods: {
    dealPrice() {
      // console.log(1221, this.priceList)
      const updatedVersionList = this.versionList.map((item) => {
        const versionName = item.alisTitle
        const priceData = this.priceList.find((d) => d.name === versionName)

        if (priceData) {
          const updatedItem = {
            ...item,
            price: priceData.annualPrice.toString()
          }
          // 单位 购买时长 buyNumber 购买时长的单位 1: 年, 2: 月 buyUnit
          const buyNumber =
            Number(priceData.buyNumber) > 1 ? priceData.buyNumber : ''
          const unit = priceData.buyUnit == 2 ? '月' : '年'
          updatedItem.unit = '元/' + buyNumber + unit

          // 根据 isSend 字段处理促销信息
          if (priceData.isSend) {
            updatedItem.tag =
              priceData.isSend === 1
                ? `最高送${priceData.sendNumber}${
                    priceData.sendUnit == 1 ? '年' : '月'
                  }`
                : ''
          }

          return updatedItem
        }
        return item
      })

      this.versionList = updatedVersionList

      const updatedModuleList = this.moduleList.map((item) => {
        const moduleName = item.title
        const priceData = this.priceList.find((d) => d.name === moduleName)
        if (priceData) {
          const updatedItem = {
            ...item,
            price: priceData.annualPrice.toString()
          }
          // 单位 购买时长 buyNumber 购买时长的单位 1: 年, 2: 月 buyUnit
          const buyNumber =
            Number(priceData.buyNumber) > 1 ? priceData.buyNumber : ''
          const unit = priceData.buyUnit == 2 ? '月' : '年'
          updatedItem.unit = '元/' + buyNumber + unit

          return updatedItem
        }
        return item
      })
      this.moduleList = updatedModuleList
    },
    btnClick() {
      window.open('http://zxcerp.djcps.com/')
    }
  }
}
</script>
<style scoped lang="scss">
.yzx-price {
  margin-top: -10px;
}
.version-price-container {
  padding: 0 60px;
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
  .version-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
  }
  .pricing-card {
    background: #ffffff;
    border-radius: 8px;
    width: 100%;
    // max-width: 360px;
    padding: 24px;
    text-align: center;
    position: relative;
    display: flex;
    margin-bottom: 24px;
    .left-price {
      width: 35%;
      .title {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        margin-bottom: 16px;
      }
      .subtitle {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-bottom: 15px;
      }
      .price {
        margin-bottom: 28px;
        .amount {
          font-weight: bold;
          font-size: 32px;
          color: #333333;
        }
        .unit {
          font-weight: 400;
          font-size: 16px;
          color: #4c545d;
        }
      }
      .btn {
        width: 70%;
        padding: 10px;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        margin-bottom: 16px;
        transition: all 0.3s;
      }
      .btn-outline {
        background: #ffffff;
        color: #333;
        border: 1px solid #ededed;
      }
      .btn-primary {
        background: #e0edff;
        color: #0064eb;
      }

      .btn-highlight {
        background: #ffd173;
        color: #73450f;
      }
      .tag {
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(90deg, #ffe9c8 0%, #f4d3a4 100%);
        border-radius: 8px 0px 8px 0px;
        font-weight: 600;
        font-size: 14px;
        color: #cc6a1b;
        padding: 4px 8px;
        z-index: 1;
      }
    }

    .icon-wrapper {
      padding-top: 40px;
      padding-bottom: 24px;
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }
    .right-features {
      flex: 1;
      .advantages-agile {
        display: flex;
        align-items: center;
        padding-left: 16px;
        height: 51px;
        background: #f1f2f4;
        border-radius: 4px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .advantages-pro {
        display: flex;
        align-items: center;
        padding-left: 16px;
        height: 51px;
        background: #fff6e3;
        border-radius: 4px;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
      }

      .features {
        list-style: none;
        // margin-top: 12px;
        // border-bottom: 1px solid #ededed;
        // padding-top: 16px;
      }

      .features-item {
        padding: 12px 0;
        border-bottom: 1px solid #ededed;

        font-size: 14px;
        color: #333;

        display: flex;
        align-items: flex-start;
        flex-direction: column;
        text-align: left;
        .features-item_title {
          font-weight: 600;
          font-size: 16px;
          padding: 12px 0;
        }
        .features-item_subtitle {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          padding: 12px 0;
          .check {
            width: 14px;
            height: 14px;
            margin-right: 8px;
          }
        }
      }
      .features-item:last-child {
        border-bottom: none;
      }
    }
  }
}
.pricing-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

// .pricing-cards {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   justify-content: center;
// }

.pricing-cards {
  flex-direction: column;
}

.pricing-card {
  width: 100%;
  max-width: none;
}

.pricing-card .btn {
  padding: 8px;
}
.module-price-container {
  padding: 0 30px;
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
  .module-title {
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    margin: 15px 0;
  }
  .module-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
  }
  .module-card {
    background: white;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    // max-width: 400px;
    position: relative;

    .image-wrapper {
      background: #a8b2c7;
      border-radius: 4px 4px 0px 0px;
      position: relative;
      width: 100%;
      // height: 0;
      // padding-bottom: 120%;
      overflow: hidden;
    }
    .img-box {
      background: white;
      margin: 16px 0 0 16px;
      width: 100%;
      height: 100%;
    }
    .img-box img {
      width: 60%;
      height: 100%;
      object-fit: cover;
    }
    .module-content {
      padding: 12px;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .module-content_title {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        margin-bottom: 4px;
      }
      .module-content_subtitle {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .module-content_price {
        display: flex;
        align-items: baseline;
        font-weight: 400;
        font-size: 16px;
        color: #4c545d;
        .amount {
          font-weight: bold;
          font-size: 32px;
          color: #fa6400;
        }
        .unit {
          margin-left: 4px;
        }
      }
    }
  }
}

@media (min-width: 751px) and (max-width: 960px) {
  .version-price-container {
    padding: 0 60px;
    version-cards {
      flex-direction: row;
      gap: 16px;

      .price-box {
      }
    }
  }
}
@media (min-width: 961px) {
  .version-price-container {
    .version-cards {
      flex-wrap: nowrap;
      gap: 24px;

      .pricing-card {
        width: calc(33.33% - 12px);
        flex-direction: column;
        .left-price {
          width: 100%;
        }
      }
    }
  }
  .module-price-container {
    .module-cards {
      flex-wrap: nowrap;
      gap: 30px;
    }
  }

  .module-card {
    width: calc(33.33% - 15px);
  }
}
</style>
